import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { _AbcSplitterComponent } from '@barthauer/abc/ui-components/abc-splitter';
import { ItemClickEvent } from 'devextreme/ui/tree_view';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CategoryListComponent } from './core/category-list/category-list.component';
import { CategoryViewComponent } from './core/category-view/category-view.component';
import { ActionButton, UiSettings } from './models/protocol-viewer.model';
import { ProtocolViewerService } from './protocol-viewer.service';
@Component({
    selector: 'abc-protocol-viewer',
    templateUrl: './protocol-viewer.component.html',
    styleUrls: ['./protocol-viewer.component.scss'],
    imports: [CommonModule, _AbcSplitterComponent, CategoryListComponent, CategoryViewComponent]
})
export class ProtocolViewerComponent implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild('categoryListComponent') categoryListComponent: CategoryListComponent;
  @ViewChild('categoryViewComponent') categoryViewComponent: CategoryViewComponent;

  public UiSettings = UiSettings;
  public actionButtons: ActionButton[];

  private $unsubscribe = new Subject();
  public categoryDescriptionInfo: string;

  constructor(private protocolViewerService: ProtocolViewerService) {}

  ngOnInit(): void {
    this.categoryDescriptionInfo = this.protocolViewerService.categoryDescriptionInfos.values().next().value;
  }
  ngOnDestroy(): void {
    this.$unsubscribe.next(null);
    this.$unsubscribe.complete();
  }

  ngAfterViewInit(): void {
    this.categoryListComponent?.categoryListTree?.onItemClick
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((event: ItemClickEvent) => {
        this.categoryViewComponent?.refreshView(event.itemData.id);
        this.categoryDescriptionInfo = this.protocolViewerService.categoryDescriptionInfos.get(event.itemData.id);
      });
  }
}
